export const formatRequisite = (input: string): string => {
  const digits = input.replace(/[+() -]/g, '')

  // 📞 Телефон: начинается с 7, длина 11
  if (/^7\d{10}$/.test(digits)) {
    return digits.replace(/^7(\d{3})(\d{3})(\d{2})(\d{2})/, '+7 $1 $2 $3 $4')
  }

  // 💳 Карта
  if (digits.length >= 13 && digits.length <= 19) {
    return digits.replace(/(\d{4})(?=\d)/g, '$1 ').trim()
  }

  // 🏦 Счёт: 20 цифр
  if (digits.length === 20) {
    return digits.replace(/(\d{4})(?=\d)/g, '$1 ').trim()
  }

  // 🔙 Фоллбэк
  return input
}